import en_US from '@uppy/locales/lib/en_US.js';
import datepickerEn from 'air-datepicker/locale/en';

// locales/en.ts
const { dateFormat, timeFormat, ...datepicker } = datepickerEn;
/** Параметры ввода и сохранения данных для языка en. */
const enInputFormats = {
    dateFormat,
    timeFormat,
    archivalDateDecadeSuffix: 's'
};
const en = {
    lang: "en",
    askDeleteCollectionItems: 'Delete selected items?',
    alertDeleteItems: 'These items will be permanently deleted <br/>and cannot be recovered. <br/>Are you sure?',
    apply: "Apply",
    close: 'Close',
    cancel: 'Cancel',
    confirm: 'Confirm',
    closeUnsavedTabConfirmation: 'The form contains unsaved data.\nClose without saving?',
    confirmDeleting: 'Confirm the deletion of the item.',
    error: 'Error',
    loading: 'Loading...',
    notFound: 'Not found',
    nonBreakingSpace: 'Non-breaking space',
    pageContainsUnsavedData: "Page contains unsaved data.",
    progress: 'Working',
    copiedUrl: "Link is copied",
    copiedToBuffer: "Text copied",
    warning: 'Warning',
    search: 'Search',
    copySelected: 'Copy Selected',
    cutSelected: 'Cut selected',
    deleteFolder: "Delete folder",
    delMark: 'Change Delete Mark',
    edit: 'Edit',
    editGroup: 'Rename group',
    filter: "Filter",
    insert: 'Insert',
    insertCopy: 'Insert with copy',
    insertGroup: 'Insert Group',
    pasteRows: 'Paste rows',
    reload: "Reload",
    save: 'Save',
    saveChangesAndClose: 'Save Changes And Close',
    deleteRow: "Delete row",
    changeGroup: 'Change Group',
    confirmation: 'Confirmation required',
    askDeleteRows: 'Delete selected rows?',
    askDeleteFolders: 'Delete selected folders?',
    askDelMarkRows: 'Change deletion marks?',
    titleRequired: 'Title required',
    moveUp: "Move up",
    moveDown: "Move down",
    expandText: 'Expand text',
    selectedCount: '{0} selected',
    mapZoomHint: 'Use <span>&#8984;/Ctrl + scroll</span> to zoom',
    archivalDateYearRangePlaceholder: 'y-y',
    archivalDateDecadePlaceholder: 'dec',
    archivalDateYearPlaceholder: 'y',
    archivalDateMonthPlaceholder: 'm',
    archivalDateDayPlaceholder: 'd',
    archivalDateDayRangePlaceholder: 'd-d',
    // Autocomplete, mixed mode: {0} — text typed by the operator
    acUseAsText: 'Use “{0}” as text',
    // 2026-09-22: live notification of new messages: {0} - module name, {1} - count
    newMessageIn: 'New message in {0}',
    newMessagesIn: 'New messages in {0}: {1}',
    acCreate: 'Create record “{0}”',
    acOpenCard: 'Open record',
    acReplace: 'Replace record',
    acSelectRecord: 'Select from reference',
    acConvertToText: 'Convert to text',
    acClear: 'Clear',
    acReferenceBadge: 'Reference record',
    acReferenceNameMissing: 'Record name is not available',
    alertDeleteRows: 'These rows will be permanently deleted <br/>and cannot be recovered. <br/>Are you sure?',
    alertDeleteFolders: 'These folders will be permanently deleted <br/>and cannot be recovered. <br/>Are you sure?',
    alertDelMarkRows: 'Change deletion mark of selected rows?',
    dataLoading: 'Data loading...',
    groupSelect: 'Select group',
    noItemsSelectedToMove: 'No items are selected to move',
    selected: 'Selected',
    items: 'items',
    selectGroupWhichYouWantToMoveItems_Click: 'Select the group to which you want to move the items and click',
    createNewGroup: 'Create a new group',
    newGroupName: 'New group name',
    init: "Initialization",
    savingError: 'Save error',
    unknownEditMode: 'Unknown edit mode',
    // 2026-10-06: JSON editor check; {0} is the line where parsing stopped
    jsonInvalid: 'Invalid JSON',
    jsonInvalidAtLine: 'Invalid JSON: line {0}',
    // 2026-10-06: a table row is not saved while its fields have validation errors
    rowHasInvalidFields: 'Row not saved: correct the fields with errors',
    schemaFormModes: 'Card display mode',
    schemaFormModeDefault: 'Default',
    schemaFormModeLanguages: 'Languages',
    schemaFormModeSource: 'Source',
    schemaFormModeProvenance: 'Provenance',
    schemaFormSelectedField: 'Selected field',
    schemaFormLoading: 'Loading field details...',
    schemaFormEmpty: 'No saved details',
    schemaFormError: 'Could not load data',
    schemaFormRetry: 'Retry',
    schemaFormClose: 'Close',
    schemaFormState: 'State',
    schemaFormSource: 'Source',
    schemaFormSourcePartial: 'Source: partial',
    schemaFormOrigin: 'Origin',
    schemaFormApproval: 'Approval',
    schemaFormAttention: 'Attention',
    schemaFormAttentionAdvisory: 'Recommended to fill in',
    schemaFormAttentionBlocking: 'Required to fill in',
    schemaFormItems: 'items',
    schemaFormMore: 'more',
    schemaFormValue: 'Value',
    schemaFormAbsent: 'No saved value',
    schemaFormNull: 'Null',
    schemaFormEmptyText: 'Empty text',
    schemaFormEmptyCollection: 'Empty collection',
    schemaFormDeleted: 'Deleted',
    schemaFormUnsupported: 'Unsupported value',
    startEndTimecodeNotSpecified: 'Start or end timecode is not specified',
    startEndTooCloseToFileBoundaries: 'Start or end point is too close to the file boundaries',
    timecodeTitleImageIncorrect: 'The timecode of the title image is incorrect',
    setIn: 'Set footage In time',
    setOut: 'Set footage Out time',
    setImgTime: 'Set title image frame',
    size0: 'Switch to full screen',
    size1: 'Small player size',
    size2: 'Medium player size',
    size3: 'Big player size',
    prevFrame: 'Move to previous frame',
    prevSecond: 'Move to previous second',
    playInOut: 'Play selected footage',
    nextFrame: 'Move to next frame',
    nextSecond: 'Move to next second',
    techinfo: 'Technical options',
    timeIn: 'Footage In time',
    timeOut: 'Footage Out time',
    soundOff: 'Sound off',
    datepicker,
    upload_processing: "Processing...",
    upload_batchProcessing: "Uploading and processing",
    upload_batchComplete: "Upload complete",
    upload_batchSelected: "Selected",
    upload_batchSucceeded: "Succeeded",
    upload_batchNeedsAction: "Need attention",
    upload_batchCancelled: "Cancelled",
    upload_batchPending: "Awaiting completion",
    // 2026-10-07: upload batch notice (resultsmode = notice); plural forms separated by «|»: one|other
    upload_noticeProcessing: "Processing files: {0} of {1}",
    upload_noticeFileAttached: "File attached",
    upload_noticeAllAttached: "All {0} file attached|All {0} files attached",
    upload_noticeAttached: "{0} file attached|{0} files attached",
    upload_noticeNoneAttached: "No files attached",
    upload_noticeNeedAction: "{0} file needs attention|{0} files need attention",
    upload_noticeCancelled: "{0} file cancelled|{0} files cancelled",
    upload_noticeShowFile: "Show file",
    upload_noticeShowFiles: "Show files",
    upload_supportedFormats: "Supported formats",
    procesNotFound: "Upload process not found",
    upload_postprocessError: "Error during post-processing",
    upload_postprocessFaultToStart: "Failed to start post-processing",
    upload_fileAllreadyAdded: "File has already been added",
    upload_EmptyFile: "Empty file (size is 0 bytes)",
    upload_fileNotMatchRequirements: "The file does not meet the requirements",
    upload_unrecognizedFileType: "Unrecognized file type",
    upload_canceled: "Upload canceled",
    upload_cancel: "Cancel upload",
    upload_loading: "Uploading...",
    upload_invalidFileBlob: "Invalid file data",
    upload_httpError: "HTTP error",
    upload_networkError: "No connection to the server. Check your connection and retry the upload.",
    upload_fileUrlMissing: "Chunked upload completed without a file URL",
    systemError: "System error",
    uppy: en_US
};

export { en, enInputFormats };
